import { Popup } from 'react-map-gl/mapbox'
import { Texto, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@/utils/intl/dateTimeFormatters'
import type { PopoverInfo } from '../../types'
import { startCase } from 'lodash'
import dayjs from 'dayjs'

type BreadcrumbPopoverProps = {
  hoverInfo: Extract<PopoverInfo, { popoverType: 'arrival-departure' } | { popoverType: 'breadcrumb' }> | null
  offset?: [number, number]
}

const hideKeys = ['lat', 'lon', 'popoverType', 'id', 'timezone']

export function BreadcrumbPopover({ hoverInfo, offset }: BreadcrumbPopoverProps) {
  if (!hoverInfo) {
    return null
  }

  const latlonString = `${hoverInfo.lat.toFixed(6)}, ${hoverInfo.lon.toFixed(6)}`

  return (
    <Popup
      longitude={hoverInfo.lon}
      latitude={hoverInfo.lat}
      closeButton={false}
      closeOnClick={false}
      anchor='bottom'
      offset={offset || [0, -7]}
      className='mapbox-popover'
    >
      <Vertical gap={6}>
        {Object.entries(hoverInfo).map(([key, value]) => {
          if (hideKeys.includes(key)) {
            return null
          }
          return (
            <Vertical key={key}>
              <Texto key={key} category='p2' weight={'bold'}>
                {startCase(key)}
              </Texto>
              <Texto key={`${key}-value`} category='p2'>
                {key === 'timestamp' && value
                  ? formatters.DATE_TIME(dayjs(value), hoverInfo.timezone)
                  : startCase(String(value))}
              </Texto>
            </Vertical>
          )
        })}
        <Vertical>
          <Texto category='p2' weight={'bold'}>
            Lat/Long
          </Texto>
          <Texto category='p2'>{latlonString}</Texto>
        </Vertical>
      </Vertical>
    </Popup>
  )
}
